export enum SkeletonAnimation {
  Pulse = 'pulse',
  Wave = 'wave',
}

export type SkeletonAnimationType = SkeletonAnimation | false;
